// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"Input_inputGroup__X5xZ0","input":"Input_input__2RVY2","keyboardBtn":"Input_keyboardBtn__3fWHn"};